import { fetchData } from './fetch-data';

export async function geolocate(location) {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
    location
  )}.json?access_token=${process.env.GATSBY_MAPBOX_TOKEN}`;
  const data = await fetchData(url);
  return data;
}
